import { render, staticRenderFns } from "./yourDealer.vue?vue&type=template&id=4e5425cb&scoped=true&"
import script from "./yourDealer.vue?vue&type=script&lang=js&"
export * from "./yourDealer.vue?vue&type=script&lang=js&"
import style0 from "./yourDealer.vue?vue&type=style&index=0&id=4e5425cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5425cb",
  null
  
)

export default component.exports